<template>
  <donut-errors-base subtitle="This link has expired" :code-chars="['', '']">
    <div class="m-tx1">
      <div class="t-lg">
        <span>Go to your </span>
        <a class="link t-lg" href="/users/integrations">Integrations settings</a>
        <span> to link your Google Calendar to Donut</span>
      </div>
    </div>
  </donut-errors-base>
</template>
